/*
 * @Author: alex
 * @Date: 2022-11-14 10:25:40
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-24 09:53:21
 * @Description:
 * Copyright (c) 2022 by piesat, All Rights Reserved.
 */

export function info(msg: string, ...args: any[]) {
  console.info(
    '%c vmap ',
    'background:#41b883;color:#fff;border-radius: 2px;line-height:24px;',
    `[info] ${msg} `,
    args.length == 1 ? args[0] : args
  )
}

export function warn(msg: string, ...args: any[]) {
  console.warn(
    '%c vmap ',
    'background:#FFA500;color:#fff;border-radius: 2px;line-height:24px;',
    `[warn] ${msg} `,
    args.length == 1 ? args[0] : args
  )
}

export function error(msg: string, ...args: any[]) {
  console.error(
    '%c vmap ',
    'background:#ff4500;color:#fff;border-radius: 2px;line-height:24px;',
    `[error] ${msg} `,
    args.length == 1 ? args[0] : args
  )
}
